import React from 'react'
import { useTranslation } from 'react-i18next'
import { useMatch } from 'react-router-dom'

// Note: not the `@/factories` barrel - it drags in the toast factory and build-time globals.
import { getPathString } from '@/factories/create-router-factory'

import { RESIDENT_PROFILE_TAB_BY_SOURCE } from './resident-profile-link.constants'
import * as S from './resident-profile-link.styled'
import { ResidentProfileLinkProps } from './resident-profile-link.types'

// Note: render this INSIDE the cell's name Typography (wrapping only the name text), not around
// it - an inline anchor keeps the underline on the text and the cell's own truncation working.
export const ResidentProfileLink = ({
  clientId,
  source,
  children,
  onClick,
  ...rest
}: ResidentProfileLinkProps) => {
  const { t } = useTranslation(['clients'])
  const profileMatch = useMatch('/dashboard/clients/:clientId')

  // Note: the Resident Profile's module tabs reuse these same tables - a name there is the open
  // profile itself, so it stays plain text instead of linking back to the current page.
  const isCurrentProfile = profileMatch?.params.clientId === String(clientId)

  if (!clientId || isCurrentProfile) return <>{children}</>

  const to = getPathString({
    params: { clientId },
    path: '/dashboard/clients/:clientId',
    queryParams: { tab: RESIDENT_PROFILE_TAB_BY_SOURCE[source] },
  })

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    // Note: tables with a primary row action (e.g. Maintenance's preview) must not also fire it.
    event.stopPropagation()
    onClick?.(event)
  }

  return (
    <S.ResidentLink
      {...rest}
      to={to}
      aria-label={t('clients:profileLink.ariaLabel', { name: children })}
      onClick={handleClick}
    >
      {children}
    </S.ResidentLink>
  )
}
